import styled, { css } from 'styled-components'

import { Link, LinkProps } from '@Components/Link'
import { NavigationEvent } from '@Events/Navigation'
import { up } from '@Globals/Style/breakpoints'
import { box, flexCenterChildren } from '@Globals/Style/mixins'

import { Variant } from './index'

export interface TrustIconProps {
  variant: Variant
}

const iconStyling = ({ variant }: TrustIconProps) => css`
  ${flexCenterChildren}

  ${variant === 'footer' && css`
    display: none;

    ${up('desktop')} {
      display: flex;
      img {
        width: 70px;
        margin: 0 10px;
      }
    }
  `}
  ${variant !== 'footer' && css`
    img {
      ${box({ height: '80px', width: 'initial' })}
      margin: 10px;
    }
  `}
`

export const Icons = styled.div<TrustIconProps>`
  ${iconStyling}
`

export const IconLink = styled(Link)<LinkProps & TrustIconProps>`
  ${iconStyling}
`

export const getMobileNavEvent = (destPageTypeId: string, variant: Variant) => {
  if (variant !== 'mobile-menu') {
    return undefined
  }

  return new NavigationEvent({
    attributes: {
      dest_page_type: 'external',
      dest_page_type_id: destPageTypeId,
      source_id: 'mobile_menu_footer',
    },
    eventName: 'nav_link_click',
  })
}
